// frontend/admin-portal/src/services/authService.js
import api from './axiosConfig';

export const authService = {
    login: async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        return data.data;
    },
    logout: async () => {
        const refreshToken = localStorage.getItem('refreshToken');
        try { await api.post('/auth/logout', { refreshToken }); }
        finally { localStorage.clear(); }
    },
    me: async () => {
        const { data } = await api.get('/auth/me');
        return data.data.user;
    },
    changePassword: async (currentPassword, newPassword) => {
        const { data } = await api.post('/auth/change-password', { currentPassword, newPassword });
        return data;
    },
};